/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Siden ble ikke funnet",
  "ComingSoon": "Kommer snart",
  "YesanPersonalFinance": "Yesan, personlig økonomi",
  "Yesan": "Yesan",
  "PersonalFinance": "Personlig økonomi",
  "YesanDownload": "Yesan Last ned",
  "ThisWebsiteUsesCookies": "Vi bruker informasjonskapsler for å samle inn og analysere informasjon om nettstedets ytelse og bruk, og for å tilby funksjoner for sosiale medier. Ved å fortsette, samtykker du til vår",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Bli økonomisk fri",
  "inStepsAndActions": "i 8 trinn og 3 handlinger.",
  "TrackPlanAnalyze": "Spor. Planlegg. Analyser.",
  "FTrack": "1. Spor",
  "FPlan": "2. Planlegg",
  "FAnalyze": "3. Analysere",
  "Features": "Funksjoner",
  "FeaturesSubHeading": "Dette er appen du trenger for å bli økonomisk fri, uansett om du er nybegynner eller allerede har økonomiske kunnskaper.",
  "ManageAccounts": "Administrer kontoer",
  "CashLiquidFixedAssetsLiabilities": "Kontanter, likvide midler, anleggsmidler og gjeld.",
  "TrackTransactions": "Spor transaksjoner",
  "IncomesExpensesTransferInvestments": "Inntekter, utgifter, overføringer, investeringer.",
  "ImportExport": "Importer/eksporter",
  "YourDataAlwaysAccessible": "Dataene dine er alltid tilgjengelige.",
  "PlanYourFreedom": "Planlegg friheten din",
  "StepsAwayFromFI": "8 skritt unna økonomisk uavhengighet.",
  "BudgetsAndGoals": "Budsjetter og mål",
  "CheckYourProgressAndAchieve": "Sjekk fremdriften og nå dine økonomiske mål.",
  "DashboardAndAnalytics": "Dashboard og analyse",
  "ReviewLearnOptimizeWith": "Gjennomgå, lær og optimaliser med diagrammer, innsikt og verktøy.",
  "Security": "Sikkerhet",
  "MilitaryGradeEncryption": "Kryptering på militærnivå, støtte for biometri, data lagres på enhetene dine.",
  "OfflineMode": "Frakoblet modus",
  "YourDataAlwaysAccessibleAndModif": "Dataene dine er alltid tilgjengelige og kan endres.",
  "Track": "Spore",
  "Income": "Inntekt",
  "Expense": "Utgifter",
  "Transfer": "overføringer",
  "transactionsAndManageAccounts": "transaksjoner og administrere ulike kontoer:",
  "checkings": "Sjekke",
  "savings": "Sparepenger",
  "realEstate": "Eiendom",
  "stocks": "Aksjemarkeder",
  "bonds": "Obligasjoner",
  "crypto": "Krypto",
  "notes": "Sedler, kontanter Lommebok",
  "envelopes": "Konvolutter",
  "privateEquity": "Privat egenkapital",
  "metal": "Metall",
  "retirement": "Pensjonering",
  "lifeInsurance": "Livsforsikring",
  "intellectualProperty": "Intellektuell eiendom",
  "otherLiquidAsset": "Andre likvide midler",
  "otherFixedAsset": "Andre anleggsmidler",
  "mortgage": "Boliglån",
  "loan": "Forbrukslån",
  "creditCard": "Kredittkort",
  "otherLiability": "Annen gjeld",
  "AccountsManagement": "Administrasjon av kontoer",
  "MultipleAccountsTypesAndGrouping": "Flere kontotyper og gruppering",
  "LinkAccounts": "Koble til kontoer fra institusjonene dine (kun tilgjengelig i enkelte land)",
  "SmartAccounts": "Smarte kontoer",
  "AddEditDeleteTransactions": "Legge til / redigere / slette transaksjoner",
  "TickVerifiedTransactions": "Kryss av for bekreftede transaksjoner",
  "CategorizeTransactions": "Kategorisere transaksjoner",
  "TagTransactions": "Merk transaksjoner",
  "TrackKakeiboType": "Spor Kakeibo-type",
  "TrackInvestments": "Spor investeringer (kun tilgjengelig i enkelte land)",
  "ImportFromCSVFile": "Importer transaksjoner i sin helhet eller trinnvis fra CSV-fil",
  "ExportToCSVFile": "Eksporter transaksjoner til CSV-fil",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 trinn mot økonomisk uavhengighet, detaljert budsjettering, nå dine økonomiske mål raskere.",
  "levelsTowardsFI": "8 nivåer mot økonomisk uavhengighet",
  "EstablishBudgetsPer": "Opprett budsjetter per",
  "account": "konto",
  "accountType": "kontotype",
  "KakeiboType": "Kakeibo-type",
  "category": "kategori",
  "tag": "tag",
  "label": "etikett",
  "TrackBudgetsPerFrequency": "Spor budsjetter per frekvens",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Opprett mål for utgifter, saldo, kontantstrøm og handlinger",
  "TrackGoalsProgress": "Følg fremdriften for målene",
  "ReviewLearnOptimizeWithReportsCharts": "Gjennomgå, lær og optimaliser med rapporter, diagrammer, trender, innsikt og verktøy.",
  "Dashboard": "Dashboard",
  "FSNetWorth": "Finansielle oversikter: Nettoformue",
  "FSPnL": "Finansielle oversikter: Resultatregnskap / Resultat og tap",
  "FSBalanceSheetAssetsLiabilities": "Regnskap: Balanse, eiendeler, gjeld",
  "FSCashFlow": "Finansregnskap: Kontantstrømoppstilling, debet, kreditt, strømmer",
  "FSFlows": "Finansregnskap: Strømmer",
  "FSRatios": "Finansregnskap: Forholdstall",
  "TrendsMonthEnd": "Trender ved månedsslutt: Inntekter og kostnader, kontantstrøm",
  "TrendsPerformance": "Resultatutvikling: YoY, MoM, WoW",
  "IncomeTrendsPer": "Inntektsutvikling per",
  "SpendingTrendsPer": "Utgiftstrender per",
  "RecurringItemsIE": "Tilbakevendende poster: Inntekter og utgifter",
  "DebtProgressTrends": "Trender for gjeldsutvikling",
  "KakeiboMTDReviewTrends": "Kakeibo: MTD-gjennomgang, siste måned, trender",
  "FIWCLE": "Økonomisk uavhengighet: Veggdiagram, utgifter etter livsenergi",
  "DebtPaydownSnowballAvalanche": "Nedbetaling av gjeld: Snøball, Snøskred",
  "FullyCustomizableAnalyticsRange": "Fullt tilpassbare tidsintervaller for analyse",
  "ContactUs": "Kontakt oss",
  "Privacy": "Personvern",
  "Terms": "Vilkår",
  "About": "Om dette",
  "IAgreeToThe": "Jeg samtykker til",
  "AndThe": "og",
  "PrivacyPolicy": "personvernerklæringen",
  "TermsOfUse": "Vilkår for bruk",

  "DigitalSoftwareExperienceTagline": "Digital programvareopplevelse for den moderne verden",
  "DigitalExperience": "Digital opplevelse",
  "SoftwareForTheModernWorld": "Programvare for den moderne verden",
  "MobileApplications": "Mobilapplikasjoner",
  "forConnectedAndOfflineHumans": "for tilkoblede og frakoblede mennesker",
  "CloudSaaS": "SaaS i nettskyen",
  "ResponsiveAndWebServices": "Responsive tjenester og webtjenester",
  "PersonalFinanceServices": "Tjenester for personlig økonomi",
  "YS_p1": "Yesan er et dynamisk programvareselskap som spesialiserer seg på utvikling av banebrytende mobilapplikasjoner skreddersydd for forbrukere. Yesan har en god forståelse av de skiftende behovene og preferansene til dagens teknologikyndige brukere, og er opptatt av å skape intuitive, engasjerende og funksjonsrike mobilopplevelser som beriker brukernes liv.",
  "YS_p2": "Kjernen i Yesans misjon er et utrettelig engasjement for innovasjon og kreativitet, og hvert produkt er omhyggelig utviklet for å levere sømløs funksjonalitet og en eksepsjonell brukeropplevelse.",
  "PersonalFinanceApplication": "Applikasjon for personlig økonomi",
  "YPF_p1": "Yesan, Personal Finance er en banebrytende mobilapplikasjon for personlig økonomi som er utviklet for å gi brukerne omfattende verktøy for økonomistyring, lett tilgjengelig fra fingertuppene. Yesan, Personal Finance har et elegant og intuitivt grensesnitt og tilbyr en helhetlig tilnærming til økonomistyring som passer for brukere på alle nivåer.",
  "YPF_p2": "Blant de viktigste funksjonene er budsjettsporing, kategorisering av utgifter og transaksjonsovervåking i sanntid, slik at brukerne enkelt kan få innsikt i forbruksvanene sine. Appen tilbyr også tilpassede budsjetteringsalternativer, slik at brukerne kan sette seg økonomiske mål og følge utviklingen over tid.",
  "YPF_p3": "Yesan, Personal Finance prioriterer dessuten sikkerhet, og bruker toppmoderne krypteringsprotokoller for å beskytte brukernes sensitive finansielle informasjon. Med sikkerhetstiltak på banknivå kan brukerne trygt koble sammen kontoene sine og synkronisere transaksjoner uten at det går ut over personvernet.",
  "YPF_p4": "Yesan, Personal Finance gjør mer enn bare å lage et enkelt budsjett ved å tilby innsiktsfulle analyser og personlige anbefalinger for å optimalisere økonomiske beslutninger. Enten det dreier seg om å identifisere potensielle sparemuligheter, overvåke investeringsporteføljer eller håndtere strategier for nedbetaling av gjeld, gir appen skreddersydd innsikt som hjelper brukerne med å nå sine økonomiske mål.",
  "Discover": "Oppdag",
  "Firstname": "Fornavn",
  "Lastname": "Etternavn",
  "Company":"Selskap",
  "Subject": "Emne",
  "Email": "E-post",
  "Message": "Melding",
  "ThankYouForContactingUs": "Takk for at du kontaktet oss",
  "ValidFirstnameRequired": "Gyldig fornavn er påkrevd.",
  "ValidLastnameRequired": "Gyldig etternavn er påkrevd.",
  "ValidEmailAddressRequired": "Vennligst skriv inn en gyldig e-postadresse.",
  "ValidSubjectRequired": "Vennligst velg et gyldig emne.",
  "ValidMessageRequired": "Vennligst skriv inn en gyldig melding.",
  "UnableToSendTheFormPleaseRetryLater": "Kunne ikke sende skjemaet, vennligst prøv på nytt senere.",
  "Information": "Informasjon",
  "Sales":"Salg",
  "Support": "Støtte",
  "Press": "Trykk på",
  "Partnership": "Partnerskap",
  "Other": "Annet",
  "Blog":"Blogg",

  "Accept":"Godta",
  "Decline":"Avslag",

  "WorklogCalendar":"Worklog-kalender for Jira",

  "DirectlyAccessibleInProjectApps":"Direkte tilgjengelig i prosjektapper",
  "VisualizeWhereYouSpentYourTime":"Visualiser hvor du har brukt tiden din",
  "AllYourWorklogsInACalendar":"Alle arbeidsloggene dine i en kalender",
  "MonthSummary":"Månedsoversikt",
  "CheckIfYouForgotToLogTime":"Sjekk om du har glemt å loggføre tid.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Få direkte tilgang til sakene og oppdater tiden",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Klikk på arbeidslogg-elementet for å få direkte tilgang til problemene og redigere den registrerte tiden",
  "AlsoAvailableInDarkMode":"Også tilgjengelig i mørk modus",
  "DirectlyLogWorkOnTheCalendarVisually":"Direkte loggføring av arbeid i kalenderen visuelt",
  "ClickOnTheCalendarToCreateNewWorklog":"Klikk på kalenderen for å opprette en ny arbeidsdagbok",

  "AppsForAtlassian":"Apper for Atlassian",
  "YCL_p1":"Visualiser alle arbeidsloggene dine i en kalender med måneds-, uke-, arbeidsuke- og dagsvisning.",
  "YCL_p2":"Loggfør arbeid direkte fra kalenderen ved å velge tidsluke visuelt.",
  "YCL_p3":"Identifiser om du har glemt å registrere tid for timelistene dine.",
  "YCL_p4":"Tilgjengelig på ditt eget språk: Engelsk (Storbritannia), engelsk (USA), kinesisk (forenklet), kinesisk (tradisjonell), tsjekkisk, dansk, nederlandsk, estisk, finsk, fransk, tysk, ungarsk, islandsk, italiensk, japansk, koreansk, norsk, polsk, portugisisk (Brasil), portugisisk (Portugal), russisk, spansk, svensk, tyrkisk.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Finansportefølje for Jira",
  "BringRealFinancialPortfolio":"Få ekte finansporteføljestyring i Jira. Følg med på budsjetter, CapEx/OpEx og prosjektkostnader på ett sted.",
  "YFPAboutQ":"Hvor mye koster egentlig Jira-prosjektene våre?",
  "YFPAbout":"Financial Portfolio for Jira\nFinansledere og PMO-er sliter med å svare på et enkelt spørsmål:\nHvor mye koster egentlig Jira-prosjektene våre?\nJira sporer arbeid.\nFinansavdelingen sporer budsjetter.\nDenne appen kobler endelig de to sammen.\n\nFinancial Portfolio gjør Jira om til en lettvektig PPM- og finansplanleggingsplattform – uten behov for dyre bedriftsverktøy.",
  "YFPPorfolioQ":"Porteføljebudsjetter og sporing",
  "YFPPorfolioP":"Opprett porteføljer på tvers av flere Jira-prosjekter og definer: Budsjettbeløp, valuta, datointervall, inkluderte prosjekter, team. Spor faktiske kostnader automatisk etter hvert som arbeidet utføres i Jira.",
  "YFPPorfolioListQ":"Porteføljer",
  "YFPPorfolioListP":"Opprett finansielle porteføljer som kombinerer flere Jira-prosjekter, og se umiddelbart: Budsjett vs. faktiske kostnader, prosjektforbruk i sanntid, fordeling av CapEx vs. OpEx, kostnad per oppgave og prosjekt, eksporterbare finansrapporter. Alt drevet direkte av Jira-arbeidslogger.",
  "CostQ":"Automatisk kostnadsberegning",
  "CostP":"Gjør tidsregistrering om til reelle økonomiske data. Appen: Leser Jira-arbeidslogger, bruker timepriser, beregner reelle prosjektkostnader daglig. Ingen regneark. Ingen manuelt arbeid.",
  "RatesQ":"Satser",
  "RatesP":"Angi timesats per prosjekt, team, globalt",
  "ReportQ":"CSV-finansrapportering",
  "ReportP":"Eksporter porteføljefinansdata på få sekunder. Perfekt for: Økonomiteam, CFO-rapportering, budsjettplanlegging, revisjonsstøtte",
  "SettingsQ":"CapEx vs OpEx-klassifisering",
  "SettingsP":"Støtter regnskaps- og revisjonskrav. Klassifiser arbeid i: Kapitaliserbar utvikling (CapEx), Driftsarbeid (OpEx). Generer eksporterbare rapporter klare for økonomiteamene."
};

export const documents = {
};
